import type { ComponentType } from "react";
import type { ViewProps } from "../../registry/viewTypes";
import { Elsewhere } from "./Elsewhere";
import type { Source } from "./source";

/** A widget with "Show from" (ADR 0024): its own rows, then the person's other workspaces (see `Elsewhere`). */
export function withElsewhere<Cfg extends { source?: Source }>(
  View: ComponentType<ViewProps<Cfg>>,
): ComponentType<ViewProps<Cfg>> {
  function WithElsewhere(props: ViewProps<Cfg>) {
    const source = props.config.source ?? "here";
    if (source === "here" || props.quietEmpty) return <View {...props} />;
    return (
      <div className="flex flex-col gap-4">
        <View {...props} />
        <Elsewhere View={View} props={props} mode={source} />
      </div>
    );
  }
  WithElsewhere.displayName = `WithElsewhere(${View.displayName ?? View.name})`;
  return WithElsewhere;
}
